const DELETION_VALIDATOR_LAMBDA_URL = 'https://ukn5fqlssf.execute-api.ap-northeast-1.amazonaws.com/'

const DEV_AWS_USER_POOLS_ID = 'ap-northeast-1_AgekSaVWt'
const ST_AWS_USER_POOLS_ID = 'ap-northeast-1_dGRckDhQ3'
const PRD_AWS_USER_POOLS_ID = 'ap-northeast-1_bwFvWPddH'

function validator_api_url(aws_user_pools_id) {

    switch (aws_user_pools_id) {
        case PRD_AWS_USER_POOLS_ID:
            return DELETION_VALIDATOR_LAMBDA_URL + "prod/deleteAccount";
        case ST_AWS_USER_POOLS_ID:
            return DELETION_VALIDATOR_LAMBDA_URL + "stg/deleteAccount";
        case DEV_AWS_USER_POOLS_ID:
            return DELETION_VALIDATOR_LAMBDA_URL + "dev/deleteAccount";
        default:
            console.error(`Unexpected aws_user_pools_id: ${aws_user_pools_id}`);
            return DELETION_VALIDATOR_LAMBDA_URL + "dev/deleteAccount";
    }
}
function deletion_validator_api_url(aws_user_pools_id) {

    switch (aws_user_pools_id) {
        case PRD_AWS_USER_POOLS_ID:
            return DELETION_VALIDATOR_LAMBDA_URL + "prod/deleteAccount?action=delete";
        case ST_AWS_USER_POOLS_ID:
            return DELETION_VALIDATOR_LAMBDA_URL + "stg/deleteAccount?action=delete";
        case DEV_AWS_USER_POOLS_ID:
            return DELETION_VALIDATOR_LAMBDA_URL + "dev/deleteAccount?action=delete";
        default:
            console.error(`Unexpected aws_user_pools_id: ${aws_user_pools_id}`);
            return DELETION_VALIDATOR_LAMBDA_URL + "dev/deleteAccount?action=delete";
    }
}

function get_validator_api_url(aws_user_pools_id) {
    return validator_api_url(aws_user_pools_id)
}
function get_deletion_validator_api_url(aws_user_pools_id) {
    return deletion_validator_api_url(aws_user_pools_id)
}

export default {
    get_validator_api_url,
    get_deletion_validator_api_url,
};